import { useBreakpointValue } from "@chakra-ui/react";
import { ActionButton } from "@airhelp/react";
import LanguageSwitcherModal from "components/LanguageSwitcher/LanguageSwitcherModal/LanguageSwitcherModal";
import { alternateLanguages } from "config/languages";
import { useLanguage } from "contexts/LocalizationContext";
import { trackUAEvent, trackCustomEvent } from "utils/tracking";
import generateFlagKey from "./utils/generateFlagKey";
import type { FlagBoxProps } from "./FlagBox.d";

const FlagBox = ({ openModal, gaEvent, uaEvent }: FlagBoxProps) => {
  const currentLanguage = useLanguage();
  const modalSize = useBreakpointValue({ base: "full", lg: "xl" });

  const handleClick = () => {
    openModal(<LanguageSwitcherModal />, modalSize);
    trackUAEvent(uaEvent);
    trackCustomEvent(gaEvent);
  };

  if (alternateLanguages[currentLanguage]) return null;

  return <ActionButton flagKey={generateFlagKey(currentLanguage)} handleOnClick={handleClick} />;
};

export default FlagBox;
